export const PIXEL_ART_MAX_DIMENSION = 256;

export function isPixelArtCandidateDimensions(width: number, height: number): boolean {
  return Number.isFinite(width)
    && Number.isFinite(height)
    && width > 0
    && height > 0
    && width <= PIXEL_ART_MAX_DIMENSION
    && height <= PIXEL_ART_MAX_DIMENSION;
}

export function applyPixelArtRendering(image: HTMLImageElement): void {
  image.classList.toggle(
    "pixel-art",
    isPixelArtCandidateDimensions(image.naturalWidth, image.naturalHeight),
  );
}
